// Shared colour-picker component -- used in AddBucketScreen and EditBucketScreen.
// Renders a grid of named colour swatches large enough to tap comfortably on
// a phone or tablet. Each swatch is 44x44px (Apple/Google minimum tap target).

import { type Component, For } from 'solid-js';

export const COLOUR_PALETTE: { label: string; value: string }[] = [
  { label: 'Flame orange', value: '#f07a2e' },
  { label: 'Ocean blue', value: '#2d6a9f' },
  { label: 'Forest green', value: '#4a9b5f' },
  { label: 'Violet', value: '#7a4ab2' },
  { label: 'Crimson', value: '#b23a3a' },
  { label: 'Golden amber', value: '#d4a017' },
  { label: 'Teal', value: '#2a9d8f' },
  { label: 'Coral', value: '#e76f51' },
  { label: 'Slate blue', value: '#4a6fa5' },
  { label: 'Lime green', value: '#6ab04c' },
  { label: 'Hot pink', value: '#d63384' },
  { label: 'Sky blue', value: '#56b4d3' },
];

type Props = {
  value: string | null;
  onChange: (colour: string) => void;
  disabled?: boolean;
};

export const ColourPicker: Component<Props> = (props) => (
  <fieldset class="field colour-picker-fieldset" style="border:none;padding:0;margin:0;">
    <legend class="field-label">Colour</legend>
    <div class="colour-picker-grid">
      <For each={COLOUR_PALETTE}>
        {(c) => (
          <button
            type="button"
            class={`colour-picker-swatch${props.value === c.value ? ' colour-picker-swatch--selected' : ''}`}
            style={{ 'background-color': c.value }}
            aria-label={c.label}
            aria-pressed={props.value === c.value}
            onClick={() => props.onChange(c.value)}
            disabled={props.disabled}
            title={c.label}
            data-testid={`colour-swatch-${c.value.replace('#', '')}`}
          >
            {props.value === c.value && (
              <span class="colour-picker-check" aria-hidden="true">
                v
              </span>
            )}
          </button>
        )}
      </For>
    </div>
  </fieldset>
);
